// extracted by mini-css-extract-plugin
module.exports = {"select":"SelectAddress_select__2Nc0w"};